/*
 * Zapiet postcode step: state classes + failure handling.
 *
 * Sets on #storePickupApp, for zapiet-postcode-ux.css to key off:
 *   b22-pc-empty   Delivery is selected and the postcode field is empty
 *   b22-pc-filled  the postcode field has something in it
 *   b22-pc-error   a checkout was blocked and the postcode is still missing
 *
 * Two things the app does badly on its own:
 *
 * 1. The message sits below the fold on a full cart, so people click Checkout
 *    again and see nothing happen. On each blocked attempt we scroll the
 *    postcode field into view and focus it.
 * 2. Zapiet removes its own p.error after about four seconds (measured), which
 *    is easy to miss entirely. b22-pc-error is therefore sticky: it outlives
 *    the message and only clears once the field has a value (or Store Pickup
 *    is chosen), so the field someone has to fill in stays marked.
 *
 * Both the widget and the theme's #cart-footer-contents are re-rendered on
 * every cart update, so nothing is bound to the elements themselves: the input
 * listener is delegated on document and everything else is recomputed from a
 * MutationObserver. Same reason zapiet-relabel.js works this way.
 */
(function () {
  var INPUT_ID = 'deliveryGeoSearchField';
  var hadError = false;
  var blocked = false;

  function app() {
    return document.getElementById('storePickupApp');
  }

  function deliverySelected(root) {
    // Zapiet shows one .checkoutMethodContainer at a time; the delivery pane is
    // absent (or hidden) when Store Pickup is the chosen method.
    var pane = root.querySelector('.checkoutMethodContainer.delivery');
    if (!pane) return false;
    return pane.offsetParent !== null || pane.getClientRects().length > 0;
  }

  function drawerIsOpen() {
    var drawer = document.getElementById('cart-drawer');
    if (!drawer) return document.body.contains(document.getElementById(INPUT_ID));
    return !drawer.hasAttribute('hidden');
  }

  function focusPostcode() {
    var input = document.getElementById(INPUT_ID);
    if (!input || !drawerIsOpen()) return;
    try {
      input.scrollIntoView({ block: 'center', behavior: 'smooth' });
      input.focus({ preventScroll: true });
    } catch (e) {
      input.scrollIntoView();
      input.focus();
    }
  }

  function sync() {
    var root = app();
    if (!root) return;

    var input = document.getElementById(INPUT_ID);
    var hasValue = !!(input && input.value.trim());
    var onDelivery = deliverySelected(root);
    var showingMessage = !!root.querySelector('p.error');

    if (showingMessage) blocked = true;
    if (hasValue || !onDelivery) blocked = false;

    root.classList.toggle('b22-pc-filled', hasValue);
    root.classList.toggle('b22-pc-error', blocked);
    root.classList.toggle('b22-pc-empty', onDelivery && !hasValue && !blocked);

    // Only on the transition into the message, so re-renders don't steal focus
    // back while someone is mid-type.
    if (showingMessage && !hadError) focusPostcode();
    hadError = showingMessage;
  }

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      sync();
    });
  }

  function init() {
    sync();

    // Delegated so it survives the widget being re-rendered.
    document.addEventListener('input', function (event) {
      if (event.target && event.target.id === INPUT_ID) schedule();
    }, true);
    document.addEventListener('click', schedule, true);

    // Watch for Zapiet rendering, the Delivery/Pickup toggle, and the theme
    // replacing the cart footer. Attributes are deliberately not observed:
    // sync() only changes classes, so it cannot re-trigger itself.
    new MutationObserver(schedule).observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
